<nz-spin [nzSpinning]="loading">
  <div class="wmsm-box" >
    <div class="条件区">
      <app-wmsm-contract   [ShowSite]="true" [ShowTemplate]="false"   [ShowSchedule]="true"   [BuyerRole]="Role" [VendorRole]="VendorRole"
        (listenForm)="getFormValue($event)" (outQuery)="getQuery($event)" [QueryFromContract]="onQueryClick()"></app-wmsm-contract>
    </div>
    <div class="信息区" style="float: right"></div>
    <nz-card>
    <div>
      <strong class="margin-left-8 result">{{ "Results" | translate}}({{total}})</strong>
    </div>
    <div class="合同模板" >
      <nz-table #colSpanTable [nzData]="listOfData" style="margin-bottom: 10px" nzSize="middle" nzShowSizeChanger
        [nzFrontPagination]="false" [nzShowPagination]='false' [nzPageSize]='pageSize' [nzPageIndex]='pageIndex'
        [nzScroll]="{ x:'1800px'}" [nzPageIndex]='pageIndex' (nzCurrentPageDataChange)="onCurrentPageDataChange($event)">
        <thead>
          <tr>
            <th scope="col" nzWidth="30px" [(nzChecked)]="checked" [nzIndeterminate]="indeterminate"
              (nzCheckedChange)="onAllChecked($event)"></th>
              <th scope="col" nzWidth="150px">{{ "ID" | translate}}</th> 
            <th scope="col" nzWidth="150px">{{ "contractname" | translate}}</th>
            <th scope="col" nzWidth="110px">{{ "contractversion" | translate}}</th>
            <th scope="col" nzWidth="120px">{{ "Buyer" | translate}}</th>
            <th scope="col" nzWidth="100px">{{ "VendorCode" | translate}}</th>
            <th scope="col" nzWidth="150px">{{ "VendorName" | translate}}</th>
            <th scope="col" nzWidth="60px">{{ "schedule" | translate}}</th>
            <th scope="col" nzWidth="100px">{{ "SendDate" | translate}}</th>
            <th scope="col" nzWidth="100px">{{ "ExpirationDate" | translate}}</th>
            <th scope="col" nzWidth="70px">{{"Pending days"}}</th>
            <th scope="col" nzWidth="100px">{{ "BuyerOperationDate" | translate}}</th>
            <th scope="col" nzWidth="110px">{{ "VendorPhone" | translate}}</th>
            <th scope="col" nzWidth="100px">{{ "VendorOperationDate" | translate}}</th>
            <th scope="col" nzWidth="80px" [nzRight]="fixedColumn" style="text-align:center;">{{ "ContractTemplate" | translate}}</th>
            <th scope="col" nzWidth="80px" [nzRight]="fixedColumn" style="text-align:center;">{{"SignedContract" | translate}}</th>
            <th scope="col" nzWidth="80px" [nzRight]="fixedColumn" *ngIf="Role" style="text-align:center;">{{"GoverningDocument" | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of listOfData;let i=index">
            <td [nzChecked]="setOfCheckedId.has(data.Sid)" [nzDisabled]="data.schedule=='2' || data.schedule=='6'  || data.schedule=='5' || data.schedule=='7' || data.schedule=='8'  " (nzCheckedChange)="onItemChecked(data.Sid, $event)"></td>
            <td>{{data.contractScheduleID}}</td>
            <td>{{data.chContractName}}</td>
            <td>{{data.versions}}</td>
            <td>{{data.buyerName}}</td>
            <td>{{data.vendorCode}}</td>
            <td>{{data.vendorName}}</td>

            <td *ngIf="data.schedule=='0'">{{"Sent"| translate}}</td>
            <td *ngIf="data.schedule=='1'">{{"Uploaded"| translate}}</td>
            <td *ngIf="data.schedule=='2'">{{"Approved1"| translate}}</td>
            <td *ngIf="data.schedule=='3'">{{"Reject1"| translate}}</td>
            <td *ngIf="data.schedule=='4'">{{"NotApproved"| translate}}</td>
            <td *ngIf="data.schedule=='5'">{{"Terminate"| translate}}</td>
            <td *ngIf="data.schedule=='6'">{{"Finish"| translate}}</td>
            <td *ngIf="data.schedule=='7'">{{"NotMaintained"| translate}}</td>
            <td *ngIf="data.schedule=='8'">{{"Maintained"| translate}}</td>
            <td>{{data.sendDate  | date:'yyyy-MM-dd'}}</td>
            <td>{{data.expirationDate  | date:'yyyy-MM-dd'}}</td>
            <td>{{data.pendingDays}}</td>
            <td>{{data.approveDate | date:'yyyy-MM-dd'}}</td>
            <td>{{data.vendorPhone}}</td>
            <td>{{data.vendorOperationDate | date:'yyyy-MM-dd HH:mm:ss'}}</td>
            <td [nzRight]="fixedColumn" style="text-align:center;">

                <!-- <span class="linkLabel" style="text-decoration:underline;color:blue">
                  <a (click)="GetFile(data)">{{data.templateFileName}}</a>

                </span> -->
                <span nz-icon nzType="file" nzTheme="twotone" nz-tooltip nzTooltipTitle="{{data.templateFileName}}" class="linkLabel" (click)="GetFile(data)" style="font-size: 20px; cursor: pointer;"></span>

            </td>

            <td *ngIf="data.vendorUptateFileToken==null && VendorRole && data.schedule=='0' " [nzRight]="fixedColumn">
              <nz-upload  [nzBeforeUpload]="beforeUploadVendorFile"               

              (nzChange)="handleChange($event)">
                <button nz-button class="upload-button default-button" 
                (click)="GetInfo(data,i)" >
                  <em nz-icon nzType="upload"></em>{{'UploadExcel'|translate}}
                </button>


                
              </nz-upload>
              <span>{{uploadedFileName}}</span>   

            </td>

            <td *ngIf="(data.vendorUptateFileToken!=null ) && VendorRole " [nzRight]="fixedColumn" style="text-align:center;">
              <!-- <span class="linkLabel" style="text-decoration:underline;color:blue">
                <a (click)="GetVendorFile(data)">{{data.uploadFileName}}</a>
              </span> -->
              <span nz-icon nzType="file" nzTheme="twotone" (click)="GetVendorFile(data)" nz-tooltip nzTooltipTitle="{{data.uploadFileName}}" style="font-size: 20px; cursor: pointer;"></span>
            </td>

            <td *ngIf="data.vendorUptateFileToken==null && VendorRole && (data.schedule=='7' || data.schedule=='4'|| data.schedule=='5' || data.schedule=='6' || data.schedule=='2' || data.schedule=='3') " [nzRight]="fixedColumn">

            </td>

            <td *ngIf="data.vendorUptateFileToken!=null && Role " [nzRight]="fixedColumn" style="text-align:center;">
              <!-- <span class="linkLabel" style="text-decoration:underline;color:blue">
                <a (click)="GetVendorFile(data)">{{data.uploadFileName}}</a>
              </span> -->
              <span nz-icon nzType="file" nzTheme="twotone" nz-tooltip nzTooltipTitle="{{data.uploadFileName}}" style="font-size: 20px; cursor: pointer;" (click)="GetVendorFile(data)"></span>
            </td>

            <td *ngIf="data.vendorUptateFileToken==null && Role && data.status=='N' && data.schedule!='7'" [nzRight]="fixedColumn">
             
            </td>
            <td *ngIf="data.vendorUptateFileToken==null && Role && data.status=='Y' && data.schedule!='7' " [nzRight]="fixedColumn">
             
            </td>
            <td *ngIf="data.vendorUptateFileToken==null && Role && data.status=='Y' && data.schedule=='7' " [nzRight]="fixedColumn">
              <nz-upload  [nzBeforeUpload]="beforeUploadVendorFile"               

              (nzChange)="handleChange($event)">
                <button nz-button class="upload-button default-button" 
                (click)="GetInfo(data,i)" >
                  <em nz-icon nzType="upload"></em>{{'UploadExcel'|translate}}
                </button>

              </nz-upload>
              <span>{{uploadedFileName}}</span>
            </td>


<td [nzRight]="fixedColumn" *ngIf="Role" style="text-align:center;" >

  <span class="linkLabel" style="text-decoration:underline;color:blue" *ngIf="data.managerEmailFileName == null">
    <a (click)="GetmanagerFile(data)">{{data.managerEmailFileName}}</a>
  </span>
  <span *ngIf="data.managerEmailFileName != null" nz-icon nzType="file"  nz-tooltip nzTooltipTitle="{{data.managerEmailFileName}}" nzTheme="twotone" style="font-size: 20px;cursor: pointer;" (click)="GetmanagerFile(data)"></span>
</td>
          </tr>
        </tbody>
      </nz-table>
      <nz-pagination style="float:right;" [(nzPageIndex)]="pageIndex" [nzTotal]="total" [nzSize]="'small'"
        nzShowSizeChanger [nzPageSizeOptions]="[10, 20, 50,100]" [nzPageSize]='pageSize'
        (nzPageSizeChange)="nzPageSizeChange($event)"  
        (nzPageIndexChange)="nzPageIndexChange($event)"></nz-pagination>
        <ng-template #renderItemTemplate let-type let-page="page">
         
          <a *ngIf="type === 'page'">{{ page }}</a>
          <a *ngIf="type === 'prev'" [style.color]="'black'">&#60;</a>
          <a *ngIf="type === 'next'" [style.color]="'black'">&#62;</a>
        </ng-template>
    </div>

    <!-- <div nz-row *ngIf="Role" style="margin-top: 20px;">
      <div nz-col [nzPush]="0">
        <button nz-button nzType="primary" class="default-button" (click)="AgainSend()">{{"retransmission"|translate}} </button>
      </div>
      <div nz-col [nzPush]="1">
        <button nz-button nzType="primary" class="default-button"  (click)="UrgeContractApproval()">{{"UrgeContractApproval"|translate}}</button>
      </div>
      <div nz-col [nzPush]="2">
        <button nz-button nzType="primary" class="default-button" (click)="Approve()">{{"Approve"|translate}}</button>
      </div>
      <div nz-col [nzPush]="3">
        <button nz-button nzType="primary" class="default-button" (click)="RejectButton()">{{"RejectButton"|translate}}</button>
      </div>
      <div nz-col [nzPush]="4">
        <button nz-button nzType="primary" class="default-button"  (click)="ShowTermination()">{{"Termination"|translate}}</button>
      </div>
    </div> -->
<!-- 
    <div nz-row *ngIf="VendorRole">

      <div nz-col [nzPush]="1">
        <button nz-button nzType="primary" class="default-button" (click)="VendorReject()" >{{"VendorReject"|translate}}</button>
      </div>


    </div> -->
  </nz-card>



  </div>
</nz-spin>



<form nz-form [formGroup]="validateForm">
  <nz-modal [(nzVisible)]="isVisible" nzTitle="{{'RejectText' | translate}}" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()">
    <ng-container *nzModalContent>
      <textarea rows="4" nz-input formControlName="GroundsRejection"></textarea>
    </ng-container>
  </nz-modal>

  <nz-modal [(nzVisible)]="isVisible1" nzTitle="{{'ApprovedEmail' | translate }}" (nzOnCancel)="ApproveCancel1()" (nzOnOk)="ApproveOk()">
    <ng-container *nzModalContent>
      <nz-upload [nzFileList]="fileList" [nzBeforeUpload]="beforeUpload">
        <button nz-button nzType="primary" class="default-button"> <span nz-icon
            nzType="upload"></span>{{"uploadAttachment"|translate}}</button>
            <span>{{ManagerEmailFileName}}</span>
      </nz-upload>
    </ng-container>
  </nz-modal>

  <nz-modal [(nzVisible)]="IsTermination" nzTitle="{{'TerminationText'| translate  }}" (nzOnCancel)="terminationCancel()" (nzOnOk)="terminationOk()">
    <ng-container *nzModalContent>
      <textarea rows="4" nz-input formControlName="TerminationText"></textarea>
    </ng-container>
  </nz-modal>

  <nz-modal [(nzVisible)]="IsReject" nzTitle="{{'ReasonsVisa'| translate  }}" (nzOnCancel)="RejectCancel()" (nzOnOk)="RejectOk()">
    <ng-container *nzModalContent>
      <textarea rows="4" nz-input formControlName="VendorRejectText"></textarea>
    </ng-container>
  </nz-modal>

</form>